import { useState, useCallback } from 'react';
import VoucherSuperpartnerService from '../services/VoucherSuperpartnerService/VoucherSuperpartnerService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useVoucherSuperpartner = () => {
    const [loading, setLoading] = useState(false);

    const updateVoucherQuantity = useCallback(async (data) => {
        setLoading(true);
        try {
            await VoucherSuperpartnerService.updateQuantity(data);
            alertService.success("Operazione eseguita con successo!", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    const getVoucherStock = useCallback(async (data) => {
        setLoading(true);
        try {
            return await VoucherSuperpartnerService.getStock(data);
        } catch (error) { handleError(error); return null; }
        finally { setLoading(false); }
    }, []);

    const getHistory = useCallback(async (data) => {
        setLoading(true);
        try {
            // Chiamiamo il servizio, che ci restituisce GIÀ i dati in formato JSON (un array)
            const responseData = await VoucherSuperpartnerService.getHistory(data);

            // --- CORREZIONE DEFINITIVA QUI ---
            // Non serve più chiamare response.json(). Lavoriamo direttamente con i dati ricevuti.
            // Ci assicuriamo solo che sia un array.
            return Array.isArray(responseData) ? responseData : [];

        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        isLoading: loading,
        updateVoucherQuantity,
        getHistory,
        getVoucherStock
    };
};

export default useVoucherSuperpartner;